export default __webpack_public_path__ + "static/media/taskade.b1b3f98c.png";